import { useReportContext } from "../../../report-context";

import useAllSources from "./useAllSources";
import useColumnMutations from "./useColumnMutations";
import useSources from "./useSources";

import { ReportColumn } from "@/types/evaluate";
import { useRerunReportColumn } from "@/queries/evals";
import { useAuth } from "@/context/auth-context";

interface UseSidebarStateProps {
  type?: "create" | "update";
}

const useSidebarState = ({ type }: UseSidebarStateProps) => {
  const reportContext = useReportContext();
  const { selectedColumn, isSidebarOpen, sortedColumns } = reportContext;

  const availableColumns: ReportColumn[] = sortedColumns;
  const isOpen = isSidebarOpen && selectedColumn;

  const sources = useSources(availableColumns);
  const allSources = useAllSources(availableColumns);
  const { isLoading } = useColumnMutations({ type });

  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const { isLoading: isRerunning } = useRerunReportColumn(userToken, reportContext.reportId);

  const handleCloseSidebar = () => {
    reportContext.closeSidebar();
  };

  return {
    selectedColumn,
    isOpen,
    isLoading: isLoading || isRerunning,
    sources,
    allSources,
    handleCloseSidebar,
  };
};

export default useSidebarState;
